import { render, staticRenderFns } from "./RateTypeSettings.vue?vue&type=template&id=4c5e466e&scoped=true&"
import script from "./RateTypeSettings.vue?vue&type=script&lang=js&"
export * from "./RateTypeSettings.vue?vue&type=script&lang=js&"
import style0 from "./RateTypeSettings.vue?vue&type=style&index=0&id=4c5e466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5e466e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5e466e')) {
      api.createRecord('4c5e466e', component.options)
    } else {
      api.reload('4c5e466e', component.options)
    }
    module.hot.accept("./RateTypeSettings.vue?vue&type=template&id=4c5e466e&scoped=true&", function () {
      api.rerender('4c5e466e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/RateTypes/RateTypeSettings.vue"
export default component.exports